/* eslint-disable */
import { Menu, MenuButton, Button, MenuList, MenuItem } from "@chakra-ui/react";
import { FlagIcon } from "react-flag-kit";
import React, { useEffect, useState } from "react";
import { BiChevronDown } from "react-icons/bi";
import { ILanguage, Languages } from "../../entities/languages/languages.model";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getMe, updateUserMe, getMeAuth } from "../../utils/store/actions/users.actions";

const LanguageMenu: React.FC<any> = (props: any) => {
  const { i18n } = props;
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const handleChange = (country: any) => {
    setSelectedCountry(country.flagCode);
    i18n.changeLanguage(country.code);
    props.updateUserMe(props.LocalUser.me.id, {
      contact: props.LocalUser.me.contact,
      email: props.LocalUser.me.email,
      firstName: props.LocalUser.me.firstName,
      id: props.LocalUser.me.id,
      internal: props.LocalUser.me.internal,
      language: country.value,
      name: props.LocalUser.me.name,
      person: props.LocalUser.me.person,
      role: props.LocalUser.me.role,
      canLogin: props.LocalUser.me.canLogin,
      canReceiveOngoingScreeningEmail: props.LocalUser.me.canReceiveOngoingScreeningEmail,
    });
    props
      .getMe()
      .then(() => props.getMeAuth());
  };
  const getLanguage = () => {
    if (props.LocalUser.me.language && Languages) {
      return Languages.find(
        (language) => props.LocalUser.me.language === language.value
      )?.flagCode;
    } else {
      return "fr";
    }
  };
  useEffect(() => {
    props
      .getMe()
    i18n.changeLanguage(props.LocalUser.me.language);
  }, [props.LocalUser.me.language]);
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<BiChevronDown />}
        color="brand.bf4"
        bg="white"
      >
        <FlagIcon
          code={(selectedCountry || getLanguage()).toUpperCase()}
          size={24}
        />
      </MenuButton>
      <MenuList color="brand.bf4">
        {Languages.map((language: ILanguage) => {
          return (
            <MenuItem
              key={language.code}
              onClick={() => handleChange(language)}
            >
              <FlagIcon code={language.flagCode} size={24} />
              &nbsp;&nbsp;{props.t(language.name)}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  getMe,
  updateUserMe,
  getMeAuth,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(LanguageMenu));
